export default {
  welcome: '将素材添加到这里，开启你的大作吧~',
  tool: {
    zoomout: '缩小',
    zoomin: '放大',
  },
  loading: '加载中...',
  loadfail: '加载失败',
}
